import React, { useState, useEffect } from "react";
import Eye from "../../../../../Assets/Images/Eye.svg";
import EyeOff from "../../../../../Assets/Images/eye-deactive.svg";
import EyeFocus from "../../../../../Assets/Images/eye-focus.svg";

const AuthTextInput = (props) => {
  const [IsActive, setIsActive] = useState(false);

  useEffect(() => {
    getAutofill();
  }, []);
  const getAutofill = () => {
    setTimeout(() => {
      var Autofilled = document.querySelectorAll("input:-webkit-autofill");
      if (Autofilled.length > 0) {
        for (let i = 0; i < Autofilled.length; i++) {
          let ElementId = Autofilled[i].id;
          document
            .getElementById(ElementId + "-placeholder")
            .classList.add("translated");
        }
      }
    }, 1000);
  };
  const handleInputEvent = () => {
    let Value = document.getElementById(props.Id).value;
    if (Value.length > 0) {
      document
        .getElementById(props.Id + "-placeholder")
        .classList.add("translated");
    } else {
      document
        .getElementById(props.Id + "-placeholder")
        .classList.remove("translated");
    }
  };
  const addFocusState = () => {
    document.getElementById(props.Id).classList.remove("filled");
    document.getElementById(props.Id + "-input").classList.add("focus");
    document
      .getElementById(props.Id + "-placeholder")
      .classList.add("translated");
    setIsActive(true);
  };
  const removeFocusState = () => {
    document.getElementById(props.Id + "-input").classList.remove("focus");
    if (document.getElementById(props.Id).value.length === 0) {
      document
        .getElementById(props.Id + "-placeholder")
        .classList.remove("translated");
    } else {
      document.getElementById(props.Id).classList.add("filled");
    }
    setIsActive(false);
    props.BlurAction();
  };
  const removeErrorState = () => {
    document
      .getElementById(props.Id + "-input")
      .classList.remove("wrong-input");
    props.BlurAction();
  };
  return (
    <React.Fragment>
      <label className="cridentials" id={props.Id + "-input"}>
        {IsActive ? (
          <img alt="password" className="icon" src={props.ActiveIcon} />
        ) : (
          <img alt="password" className="icon" src={props.Icon} />
        )}
        <input
          onChange={() => handleInputEvent()}
          type={props.Type}
          onInput={() => null}
          onClick={() => removeErrorState()}
          id={props.Id}
          onFocus={() => addFocusState()}
          autoComplete={false}
          onBlur={() => removeFocusState()}
        />
        <React.Fragment>
          {props.Type === "password" ? (
            <React.Fragment>
              {props.PasswordIsShown ? (
                <img
                  onClick={() => props.showPassword()}
                  src={EyeOff}
                  alt="show"
                  className="show-password"
                />
              ) : (
                <React.Fragment>
                  {IsActive ? (
                    <img
                      onClick={() => props.showPassword()}
                      src={EyeFocus}
                      alt="show"
                      className="show-password"
                    />
                  ) : (
                    <img
                      onClick={() => props.showPassword()}
                      src={Eye}
                      alt="show"
                      className="show-password"
                    />
                  )}
                </React.Fragment>
              )}
            </React.Fragment>
          ) : null}
        </React.Fragment>
        <p id={props.Id + "-placeholder"} className="auth-input-placeholder">
          {props.PlaceHolder}
        </p>
      </label>
    </React.Fragment>
  );
};
export default AuthTextInput;
